<template>
  <section class="mkt">
    <div class="mkt__head"><h2 class="mkt__title">Salud del mercado</h2><span class="mkt__sub">últimos 30 días</span></div>

    <div v-if="loading" class="mkt__loading"><v-progress-circular indeterminate color="accent" size="26" width="2" /></div>

    <template v-else-if="report">
      <div class="mkt__tiles">
        <div class="mkt__tile">
          <div class="mkt__num">{{ report.buyerLiquidity }}%</div>
          <div class="mkt__lbl">Liquidez compradores</div>
        </div>
        <div class="mkt__tile">
          <div class="mkt__num">{{ report.sellerLiquidity }}%</div>
          <div class="mkt__lbl">Liquidez listados</div>
        </div>
      </div>

      <div class="mkt__grid">
        <div class="mkt__col">
          <div class="mkt__collbl">Oportunidades — alta demanda, poca oferta</div>
          <div v-if="gaps.length" class="mkt__list">
            <div v-for="g in gaps" :key="g.category" class="mkt__row">
              <span class="mkt__name">{{ catLabel(g.category) }}</span>
              <span class="mkt__val">{{ g.demand }} bús. · {{ g.supply }} pub.</span>
            </div>
          </div>
          <div v-else class="mkt__empty">Oferta y demanda equilibradas.</div>
        </div>
        <div class="mkt__col">
          <div class="mkt__collbl">Zonas buscadas sin resultados</div>
          <div v-if="(report.zeroResultZones || []).length" class="mkt__list">
            <div v-for="z in report.zeroResultZones.slice(0, 5)" :key="z.label" class="mkt__row">
              <span class="mkt__name">{{ z.label }}</span>
              <span class="mkt__val">{{ z.count }}</span>
            </div>
          </div>
          <div v-else class="mkt__empty">Sin zonas sin resultados.</div>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
import { AudienceReport } from "@/graphql/queries/analytics";
import { localDateKey, BROWSER_TZ } from "@/utils/charts";

const CAT_LABELS = { living: "Vivienda", commercial: "Comercial", land: "Terrenos", parking: "Cocheras", other: "Otros" };

export default {
  data: () => ({ loading: false, report: null }),

  computed: {
    rangeDates() {
      const to = new Date();
      const from = new Date();
      from.setDate(to.getDate() - 29);
      return { from: localDateKey(from), to: localDateKey(to) };
    },
    // categories where demand outstrips supply — the real-estate "act on it" signal
    gaps() {
      return (this.report.demandVsSupply || [])
        .filter(d => (d.demand || 0) > (d.supply || 0) && (d.demand || 0) > 0)
        .sort((a, b) => (b.demand - b.supply) - (a.demand - a.supply))
        .slice(0, 4);
    }
  },

  created() {
    this.fetch();
  },

  methods: {
    catLabel(c) {
      return CAT_LABELS[c] || c;
    },
    fetch() {
      this.loading = true;
      this.$apollo
        .query({
          query: AudienceReport,
          fetchPolicy: "no-cache",
          variables: { from: this.rangeDates.from, to: this.rangeDates.to, timeZone: BROWSER_TZ, operationType: null }
        })
        .then(res => {
          this.report = res.data.audienceReport || null;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.mkt { background: #fff; border: 1px solid #ece7de; border-radius: 14px; padding: 18px 20px; box-shadow: 0 8px 24px -16px rgba(40, 33, 22, 0.18); margin-bottom: 22px; }
.mkt__head { display: flex; align-items: baseline; gap: 10px; margin-bottom: 14px; }
.mkt__title { font-size: 16px; font-weight: 700; color: #1a1814; margin: 0; }
.mkt__sub { font-size: 12px; color: #a39a8c; }
.mkt__loading { display: flex; justify-content: center; padding: 24px 0; }
.mkt__tiles { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 16px; }
.mkt__tile { background: #faf8f4; border: 1px solid #f1ece3; border-radius: 12px; padding: 14px 16px; text-align: center; }
.mkt__num { font-size: 24px; font-weight: 700; color: #1a1814; line-height: 1; }
.mkt__lbl { font-size: 12px; color: #756f64; margin-top: 6px; }
.mkt__grid { display: grid; grid-template-columns: 1fr 1fr; gap: 18px; }
@media (max-width: 720px) { .mkt__grid { grid-template-columns: 1fr; } }
.mkt__collbl { font-size: 10px; letter-spacing: 0.1em; text-transform: uppercase; color: #a39a8c; font-weight: 600; margin-bottom: 8px; }
.mkt__list { display: flex; flex-direction: column; gap: 7px; }
.mkt__row { display: flex; align-items: center; justify-content: space-between; gap: 10px; }
.mkt__name { font-size: 13px; font-weight: 600; color: #1a1814; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.mkt__val { font-size: 12px; color: #756f64; flex: none; }
.mkt__empty { font-size: 13px; color: #a39a8c; }
</style>
